module.exports = __webpack_public_path__ + "img/bt_map_zoomout_default.669b4b9f.svg";